import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useRole } from "hooks/useRole";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useGetControllerUnreadMessageCountQuery } from "features/api/messages/messagesApiSlice";
import ModalBootstrap from "components/bootstrap/ModalBootstrap";
import { useMessages } from "hooks/useMessages";

const HeaderLinks = () => {
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const { getUnreadMessagesCount } = useMessages();
  const { setUnreadMessagesCount } = useMessages();

  const role = useRole();
  const isSenior = role === UserRole.SENIOR;
  const isSeniorWatch = role === UserRole.SENIOR_WATCH;

  const {
    data: controllerUnreadMessages = 0,
    refetch,
  }: {
    data: number;
    refetch: () => void;
  } = useGetControllerUnreadMessageCountQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const headerLinksAarray = [
    {
      className: "link",
      to: "/reports/followup",
      text: t("followUpReports"),
      linkTo: "followup",
    },
  ];

  if (!isSeniorWatch) {
    headerLinksAarray.unshift({
      className: "link",
      to: "/reports/inprogress",
      text: t("pendingReports"),
      linkTo: "inprogress",
    });
  }

  if (isSenior) {
    headerLinksAarray.push({
      className: "link",
      to: "/reports/followup-messages",
      text: t("messages"),
      linkTo: "followup-messages",
    });
  }

  useEffect(() => {
    if (
      controllerUnreadMessages > 0 &&
      controllerUnreadMessages > getUnreadMessagesCount
    ) {
      setOpenPopup(true);
    }
    if (controllerUnreadMessages !== getUnreadMessagesCount) {
      setUnreadMessagesCount(controllerUnreadMessages);
    }
  }, [
    controllerUnreadMessages,
    getUnreadMessagesCount,
    setUnreadMessagesCount,
  ]);

  const closePopup = () => {
    setOpenPopup(false);
  };

  const linksJsx = headerLinksAarray.map((route) => {
    return (
      <NavLink
        {...route}
        key={route.to}
        onClick={(e) => {
          refetch();
        }}
      >
        {route.linkTo === "followup-messages" ? (
          <span>
            {route.text}
            {controllerUnreadMessages > 0 && (
              <span className="messages-counter">
                {controllerUnreadMessages}
              </span>
            )}
          </span>
        ) : (
          route.text
        )}
      </NavLink>
    );
  });
  return (
    <div>
      <ModalBootstrap
        onHide={() => closePopup()}
        show={openPopup}
        title={t("controllerNewMessages")}
        closeButtonText={t("closeMessagePopup")}
      />
      {linksJsx}
    </div>
  );
};
export default HeaderLinks;
